<form [formGroup]="substanceForm">
  <div class="form-field">
    <input
      readonly
      formControlName="productType"
      avanoInputText
      [label]="translationKeys.productDeclaration.html.type | translate"
    />
  </div>
  <div class="form-field">
    <input
      readonly
      formControlName="name"
      avanoInputText
      [label]="translationKeys.productDeclaration.html.label.name.substance | translate"
    />
  </div>
  <div class="form-field">
    <input
      readonly
      formControlName="casNumber"
      avanoInputText
      [label]="translationKeys.declarationNodeDetailsComponent.html.label.casNumber | translate"
    />
  </div>
  <div class="form-field"  [class.hidden]="!displayConcentrationRange">
    <input
      readonly
      formControlName="concentrationRange"
      avanoInputText
      [label]="translationKeys.declarationNodeDetailsComponent.html.label.percentageRange | translate"
    />
  </div>
  <div class="form-field" [class.hidden]="!vdaMaterialCategories.value">
    <input
      readonly
      formControlName="vdaMaterialCategories"
      avanoInputText
      [label]="translationKeys.declarationNodeDetailsComponent.html.vdaMaterialCategoriesLabel | translate"
    />
  </div>
  <div class="form-field" [class.hidden]="!vdaMixtureCategories.value">
    <input
      readonly
      formControlName="vdaMixtureCategories"
      avanoInputText
      [label]="translationKeys.declarationNodeDetailsComponent.html.vdaMixtureCategoriesLabel | translate"
    />
  </div>
</form>
